import { render, staticRenderFns } from "./page-holder.vue?vue&type=template&id=14e2b7f4&"
import script from "./page-holder.vue?vue&type=script&lang=js&"
export * from "./page-holder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports